// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-m_fv","advertDetailContactItem__link":"c-m_fw","advertDetailContactItem__stub":"c-m_fx"};